import React from 'react';

import * as Styled from './style';

function IdeaRow({ idea }) {
  return (
    <Styled.VotedCard>
      <Styled.CardContent>
        <Styled.VotedCount>
          <span>{idea.votes.length}</span>
          <small>{idea.votes.length === 1 ? 'Vote' : 'Votes'}</small>
        </Styled.VotedCount>
        <Styled.CardDescription>
          <Styled.BadgeColumn>{idea.columnName}</Styled.BadgeColumn>
          <pre style={{ whiteSpace: 'pre-wrap' }}>{idea.description}</pre>
        </Styled.CardDescription>
      </Styled.CardContent>
    </Styled.VotedCard>
  );
}

export default IdeaRow;
